/**
 * 判断浏览器/系统环境
 * @returns {Boolean}
 */
export function getBrowser() {
    const ua = window.navigator.userAgent || '';
    const isWeChat = /MicroMessenger/i.test(ua);
    const isWxWork = /MicroMessenger/i.test(ua) && /wxwork/i.test(ua); // 企业微信
    const isAndroid = /android/i.test(ua);
    const isIos = /iphone|ipad|ipod/i.test(ua);
    const isInTocaApp = /toca/i.test(ua);
    const isApp = /.*TcTravel.*/i.test(ua) || / ew(\w+)\/([\d.-_]*)/.test(ua);
    const isMiniProgram = function () {
        return new Promise((resolve, reject) => {
            // 先判断是否在微信浏览器环境
            if (
                navigator.userAgent.toLowerCase().indexOf('micromessenger') ==
                -1
            ) {
                resolve(false);
            } else {
                try {
                    // wx.miniProgram.getEnv((res: { miniprogram: any; }) => { // 只有小程序环境有
                    //     if (!res.miniprogram) {
                    //         resolve(false)
                    //     } else {
                    //         resolve(true)
                    //     }
                    // })
                } catch (err) {
                    resolve(false);
                }
            }
        });
    };
    const isMobile = isIos || isAndroid;

    return {
        isMobile,
        isWeChat,
        isWxWork,
        isMiniProgram,
        isAndroid,
        isIos,
        isApp,
        isInTocaApp
    };
}
